var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumenBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,2C115.77,2,2,115.75,2,256.06S115.77,510,256,510,510.05,396.28,510.05,256.06,396.31,2,256,2ZM428.57,428.54A243.14,243.14,0,1,1,480.87,351,243.34,243.34,0,0,1,428.57,428.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.67,124.78l-52-52a5,5,0,0,0-3.53-1.46H122.86v369.3H389.14V129.38H389A5,5,0,0,0,387.67,124.78ZM337.18,88.42l34.88,34.89H337.18ZM132.86,430.65V81.35H327.18v47a5,5,0,0,0,5,5h47V430.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.54,177.64H142.79V319H258.54Zm-5,136.38H147.79V182.64H253.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.43,
    y: 179.97,
    width: 100.71,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.43,
    y: 205.15,
    width: 100.71,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.29,
    y: 154.86,
    width: 100.71,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.04,
    y: 129.67,
    width: 51.08,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.43,
    y: 230.34,
    width: 100.71,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.43,
    y: 255.52,
    width: 100.71,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.43,
    y: 280.71,
    width: 100.71,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.43,
    y: 305.89,
    width: 100.71,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.29,
    y: 331.08,
    width: 221.85,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.29,
    y: 356.26,
    width: 221.85,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.29,
    y: 381.45,
    width: 221.85,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.66,255.9a7.57,7.57,0,1,0-7.57-7.57A7.57,7.57,0,0,0,200.66,255.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.66,265.91a17.58,17.58,0,1,0-17.58-17.58A17.58,17.58,0,0,0,200.66,265.91Zm0-30.16a12.58,12.58,0,1,1-12.58,12.58A12.6,12.6,0,0,1,200.66,235.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumenBlanco);
export default __webpack_public_path__ + "static/media/resumen_blanco.05f8d74e6de56b217b8bfc2a77ba1071.svg";
export { ForwardRef as ReactComponent };